/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AttendeeResponseType {
  None = "None",
  Organizer = "Organizer",
  TentativelyAccepted = "TentativelyAccepted",
  Accepted = "Accepted",
  Declined = "Declined",
  NotResponded = "NotResponded",
}

export const AttendeeResponseTypeDisplay: Record<AttendeeResponseType, string> = {
  [AttendeeResponseType.None]: "None",
  [AttendeeResponseType.Organizer]: "Organizer",
  [AttendeeResponseType.TentativelyAccepted]: "Tentatively Accepted",
  [AttendeeResponseType.Accepted]: "Accepted",
  [AttendeeResponseType.Declined]: "Declined",
  [AttendeeResponseType.NotResponded]: "Not Responded",
};
